import { NewUserData } from "@app/core/user/domain/new-user";
import { LoginResponse } from "@app/core/user/domain/login.reponse";
import { Observable } from "rxjs";
import { User } from "@app/core/user/domain/user";

/**
 * User repository.
 */
export abstract class UserRepo {
  /**
   * Register a new user and return the token and if it needs to complete the profile.
   */
  abstract register(newUserData: NewUserData): Observable<LoginResponse>;

  /**
   * Complete the user profile.
   * @param params The user profile and the token.
   */
  abstract completeProfile(params: {
    profile: User;
    token: string;
  }): Observable<void>;

  /**
   * Get the user profile.
   * @param token The token of the user.
   */
  abstract get(token: string): Observable<User>;

  /**
   * Edit the user profile.
   * @param params The new edited user profile and the token.
   * @return The edited user profile.
   */
  abstract edit(params: { profile: User; token: string }): Observable<User>;

  /**
   * Delete the user profile.
   * @param token The token of the user.
   */
  abstract delete(token: string): Observable<void>;
}
